import { Scene, ArcRotateCamera, DirectionalLight, Color3,CubeTexture } from '@babylonjs/core';
import { HotPoint } from './../displayObject/UI/HotPoint';
import { FaultPoint } from './../displayObject/UI/FaultPoint';
import { MaintainPoint } from './../displayObject/UI/MaintainPoint';
import { ProcessPoint } from './../displayObject/UI/ProcessPoint';
import { WarnPoint } from './../displayObject/UI/WarnPoint';
import { HoldPoint } from './../displayObject/UI/HoldPoint';
import { ShutdownPoint } from './../displayObject/UI/ShutdownPoint';
import { NaviMinimap } from './../displayObject/UI/NaviMinimap';
import { FacilityInfo } from './../displayObject/UI/FacilityInfo';
import { AdvancedDynamicTexture } from '@babylonjs/gui';
import { Player } from '../displayObject/player/Player';
import { CsmShadow } from '../materials/shadow/CsmShadow';
import {Skybox} from './../engine/Skybox';

interface mainObject {
    scene?: Scene,
    camera?: ArcRotateCamera,
    sunLight?: DirectionalLight,
    indoorLight?:DirectionalLight,
    indoorLight2?:DirectionalLight,
    loopFunc?: any,
    temp?: any,
    HotPoint?: HotPoint,
    fp?:FaultPoint,
    mp?:MaintainPoint,
    pp?:ProcessPoint,
    wp?:WarnPoint,
    hop?:HoldPoint,
    sp?:ShutdownPoint,
    player?:Player,
    csmObj?:CsmShadow,
    camData?:any,
    camShowed?:boolean,
    skybox?:Skybox,
    source?:any,
    camSpeed?:number,
    pixiRoot?:any,
    fancilityData?:any,
    minimap?:NaviMinimap,
    gui?:AdvancedDynamicTexture,
    fancilityInfoBox?:FacilityInfo,
    stageName?:string
}

export class GlobalObject {
    private static instance: GlobalObject;
    public main: mainObject = {};
    private constructor() {
        this.main.temp = {};
    }
    public static getInstance(): GlobalObject {
        if (!GlobalObject.instance) {
            GlobalObject.instance = new GlobalObject();
        }
        return GlobalObject.instance;
    }

    // scene
    public setScene(obj: Scene) {
        this.main['scene'] = obj;
    }
    // scene
    public setCamera(obj: ArcRotateCamera) {
        this.main['camera'] = obj;
    }
    // sunLight
    public setSunlight(obj: DirectionalLight) {
        this.main['sunLight'] = obj;
    }
    // indoorLight
    public setIndoorLight(obj: DirectionalLight) {
        this.main['indoorLight'] = obj;
    }
    public setIndoorLight2(obj: DirectionalLight) {
        this.main['indoorLight2'] = obj;
    }
    // loopFunction
    public setLoopFunc(obj: any) {
        this.main['loopFunc'] = obj;
    }
    //
    // hot point
    public setHotPoint(obj: any) {
        this.main['HotPoint'] = obj;
    }
    public setFp(obj: any) {
        this.main['fp'] = obj;
    }
    public setMp(obj: any) {
        this.main['mp'] = obj;
    }
    public setPp(obj: any) {
        this.main['pp'] = obj;
    }
    public setWp(obj: any) {
        this.main['wp'] = obj;
    }
    public setHop(obj: any) {
        this.main['hop'] = obj;
    }
    public setSp(obj: any) {
        this.main['sp'] = obj;
    }
    // player
    public setPlayer(obj: any) {
        this.main['player'] = obj;
    }
    // csmshadow
    public setShadow(obj: any) {
        this.main['csmObj'] = obj;
    }
    // 摄像头数据
    public setCamdata(obj:any){
        this.main['camData'] = obj;
    }
    // 模型/贴图/资源资源数据
    public setSource(obj:any){
        this.main.source = obj;
    }
    // 调用天空盒
    public setSkybox(obj:any){
        this.main['skybox'] = obj;
    }
    // 是否显示摄像头
    public setCamShowed(showed:boolean){
        this.main.camShowed = showed;
    }
    // 是否显示摄像头
    public setCamSpeed(speed:number){
        this.main.camSpeed = speed;
    }
    //
    public setPixiRoot(root:any){
        this.main.pixiRoot = root;
    }
    //
    public setFancilityData(data:any){
        this.main.fancilityData = data;
    }
    // 小地图类
    public setMinimap(obj:NaviMinimap){
        this.main['minimap'] = obj;
    }
    // gui -> AdvancedDynamicTexture 
    public setGUI(gui:AdvancedDynamicTexture){
        this.main['gui'] = gui;
    }
    // 
    public setFancilityInfoBox(box:FacilityInfo){
        this.main['fancilityInfoBox'] = box;
    }
    public setStageName(name:string){
        this.main['stageName'] = name;
    }
}
